import styled from "styled-components";
import { theme } from "styles/theme";

const StyledHeaderSub = styled.div`
  & .header-3rd {
    border-top: 1px solid rgb(99 7 0);
    height: 70px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${theme.colors.neutrals[900]};
    .header__wrap {
      display: flex;
      width: 100%;
      height: 100%;
      justify-content: space-around;
      align-items: center;
      padding: 0 7px;
      .menu__wrap {
        padding-left: 10px;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: space-around;
        color: ${theme.colors.background.white};
        a {
          text-decoration: none;
          color: ${theme.colors.background.white};
        }
        &-item {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          flex-direction: column;
          justify-content: space-evenly;
          font-size: 16px;
          transition: 0.25s;
          .box {
            cursor: pointer;
            width: 100%;
            height: 100%;

            display: flex;
            flex-direction: column;
            transition: 0.25s;
            align-items: center;
            justify-content: center;
            &:hover {
              color: ${theme.colors.secondary[900]};
              transition: 0.25s;
            }
            &-text {
              margin-top: 4px;
            }
          }
        }
      }
    }
  }
`;
export default StyledHeaderSub;
